import Box from "@mui/material/Box";
import { Formik, Form, FormikValues } from "formik";
import styles from "./styles.module.scss";
import { logger } from "../../../utils/logger";
import TreatmentListTable from "./TreatmentListTable";
import SearchField from "../../common/Search/Search";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import { Add, PlusOne, Search } from "@mui/icons-material";
// import UserListTable from "./UserListTable";
import SaveButton from "../../common/Button";
import { useState, useEffect } from "react";
import diseaseService from "../../../services/disease";
import { RootState, useAppDispatch } from "../../../redux/store";
import { setLoadingAction } from "../../../redux/utils/actions";
import { shallowEqual, useSelector } from "react-redux";

export type IDisease = {
  _id: string;
  name: string;
  isEditOpened: boolean;
};

export default function Treatment() {
  const [gridData, setGridData] = useState<IDisease[]>([]);

  const dispatch = useAppDispatch();
  const loading = useSelector(
    (state: RootState) => state.utils.loading,
    shallowEqual
  );

  const getData = async () => {
    try {
      dispatch(setLoadingAction(true));
      const { data } = await diseaseService.getAll();
      dispatch(setLoadingAction(false));
      const modifiedData = data.data.map((item: any) => ({
        ...item,
        isEditOpened: false,
      }));
      setGridData(modifiedData);
    } catch (err) {
      dispatch(setLoadingAction(false));
      logger.error(err);
    }
  };

  const saveHandler = async (values: FormikValues) => {
    try {
      dispatch(setLoadingAction(true));
      await diseaseService.create({ name: values.SearchField });
      getData();
      dispatch(setLoadingAction(false));
    } catch (err) {
      dispatch(setLoadingAction(false));
      logger.error(err);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{ SearchField: "" }}
        // validateOnChange={false}
        onSubmit={(
          values,
          { resetForm, setSubmitting, validateForm, setErrors }
        ) => {
          saveHandler(values);
          resetForm();
          logger.log(values);
        }}
      >
        {({
          values,
          setFieldValue,
          dirty,
          resetForm,
          handleChange,
          handleSubmit,
        }) => (
          <Form>
            <Box className={styles.sidebarStyle}>
              <Box className={styles.contentHeads}>
                <h1 className={`${styles.titleButton} mg-r-10`}>Treatment</h1>
                {/* <SearchField name="SearchField" inputHandler={inputHandler} /> */}
                <FormControl className={styles.formMaxWidth} variant="outlined">
                  <Box sx={{ display: "flex", gap: "10px" }}>
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      name={`SearchField`}
                      value={values[`SearchField`]}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                      aria-describedby="outlined-weight-helper-text"
                      inputProps={{
                        "aria-label": "weight",
                        placeholder: "Treatment name",
                      }}
                      className={styles.inputField}
                    />
                    <SaveButton
                      color="alert"
                      type="submit"
                      disabled={loading || !dirty}
                    >
                      Add
                    </SaveButton>
                  </Box>
                </FormControl>
              </Box>
              <Box>
                <TreatmentListTable
                  gridData={gridData}
                  setGridData={setGridData}
                  getData={getData}
                />
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  );
}
